const dafaultLanguage = {
    pageTitle: {
        ja: "NAPIRE Inc. | AI\u3067\u30D3\u30B8\u30CD\u30B9\u3092\u3064\u306A\u3050 \u2014 \u6CD5\u4EBA\u5411\u3051AI\u30FBDX\u30FB\u30AF\u30E9\u30A6\u30C9\u5C0E\u5165\u652F\u63F4",
        en: "NAPIRE Inc. | Connecting Business & AI \u2014 Enterprise AI, DX & Cloud"
    },
    metaDescription: {
        ja: "\u682A\u5F0F\u4F1A\u793ENAPIRE\u306FAI\u4F01\u696D\u3068\u3057\u3066\u3001\u6CD5\u4EBA\u5411\u3051AI\u30FBDX\u5C0E\u5165\u652F\u63F4\u3001SaaS\u30FB\u30AF\u30E9\u30A6\u30C9\u5C0E\u5165\u652F\u63F4\u3001\u81EA\u793EAI\u30C9\u30ED\u30FC\u30F3\u958B\u767A\u3092\u63D0\u4F9B\u3002\u751F\u6210AI\u30FBRAG\u3001\u30C7\u30FC\u30BF\u57FA\u76E4\u3001M365\u5C0E\u5165\u304B\u3089\u672C\u756A\u904B\u7528\u307E\u3067\u4E00\u6C17\u901A\u8CAB\u3067\u4F34\u8D70\u3057\u307E\u3059\u3002",
        en: "NAPIRE is an AI company offering enterprise AI/DX implementation, SaaS & cloud rollout, and in-house AI drones\u2014from GenAI/RAG and data platforms to M365 adoption and production ops."
    },
    metaKeywords: {
        ja: "NAPIRE,\u682A\u5F0F\u4F1A\u793ENAPIRE,AI\u5C0E\u5165,DX,\u6CD5\u4EBA\u5411\u3051,SaaS,\u30AF\u30E9\u30A6\u30C9,AI\u30C9\u30ED\u30FC\u30F3,IT\u4F01\u696D,\u751F\u6210AI",
        en: "NAPIRE,NAPIRE Inc.,AI implementation,DX,enterprise,SaaS,cloud,AI drone,IT company,GenAI"
    },
    nav: {
        home: {
            ja: "\u30DB\u30FC\u30E0",
            en: "Home"
        },
        aiDx: {
            ja: "AI\u30FBDX",
            en: "AI & DX"
        },
        saasCloud: {
            ja: "\u30AF\u30E9\u30A6\u30C9",
            en: "Cloud"
        },
        drone: {
            ja: "AI\u30C9\u30ED\u30FC\u30F3",
            en: "Drone"
        },
        products: {
            ja: "\u30D7\u30ED\u30C0\u30AF\u30C8",
            en: "Products"
        },
        itStore: {
            ja: "IT\u6A5F\u5668",
            en: "IT Store"
        },
        work: {
            ja: "\u5B9F\u7E3E",
            en: "Work"
        },
        about: {
            ja: "\u4F1A\u793E\u60C5\u5831",
            en: "About"
        },
        team: {
            ja: "\u30C1\u30FC\u30E0",
            en: "Team"
        },
        insights: {
            ja: "\u30A4\u30F3\u30B5\u30A4\u30C8",
            en: "Insights"
        },
        reports: {
            ja: "\u30EC\u30DD\u30FC\u30C8",
            en: "Reports"
        },
        contact: {
            ja: "\u304A\u554F\u3044\u5408\u308F\u305B",
            en: "Contact"
        },
        servicesGroup: {
            ja: "\u30B5\u30FC\u30D3\u30B9",
            en: "Services"
        },
        companyGroup: {
            ja: "\u4F1A\u793E",
            en: "Company"
        },
        drawerTitle: {
            ja: "\u30E1\u30CB\u30E5\u30FC",
            en: "Menu"
        },
        menuOpen: {
            ja: "\u30E1\u30CB\u30E5\u30FC\u3092\u958B\u304F",
            en: "Open menu"
        },
        close: {
            ja: "\u9589\u3058\u308B",
            en: "Close"
        }
    },
    home: {
        pageTitle: {
            ja: "NAPIRE Inc. | AI\u30FBIT\u3067\u30D3\u30B8\u30CD\u30B9\u3092\u3064\u306A\u3050",
            en: "NAPIRE Inc. | Connecting Business with AI & IT"
        },
        heroTitle: {
            ja: "AI\u3068IT\u3067\u3001\u73FE\u5834\u304C\u52D5\u304F\u307E\u3067\u3002",
            en: "AI & IT that moves the floor."
        },
        heroLead: {
            ja: "NAPIRE\u306FAI\u30FBIT\u4F01\u696D\u3067\u3059\u3002\u6CD5\u4EBA\u5411\u3051AI\u30FBDX\u5C0E\u5165\u652F\u63F4\u3001SaaS\u30FB\u30AF\u30E9\u30A6\u30C9\u5C0E\u5165\u652F\u63F4\u3092\u8EF8\u306B\u3001\u81EA\u793EAI\u30C9\u30ED\u30FC\u30F3\u3068\u3044\u3046\u30D7\u30ED\u30C0\u30AF\u30C8\u307E\u3067\u4E00\u6C17\u901A\u8CAB\u3067\u5C4A\u3051\u307E\u3059\u3002",
            en: "NAPIRE is an AI & IT company\u2014enterprise AI/DX, SaaS & cloud rollouts, and our own AI drone product, delivered end to end."
        },
        heroCta: {
            ja: "\u30B5\u30FC\u30D3\u30B9\u3092\u898B\u308B",
            en: "Explore services"
        },
        heroCta2: {
            ja: "\u304A\u554F\u3044\u5408\u308F\u305B",
            en: "Contact us"
        },
        stackMain: {
            ja: "AI\u30FBIT",
            en: "AI & IT"
        },
        stackMainSub: {
            ja: "\u6CD5\u4EBA\u5411\u3051\u5C0E\u5165\u652F\u63F4\u306E\u57FA\u76E4",
            en: "Enterprise implementation foundation"
        },
        stackAi: {
            ja: "AI\u30FBDX\u5C0E\u5165\u652F\u63F4",
            en: "AI & DX"
        },
        stackCloud: {
            ja: "SaaS\u30FB\u30AF\u30E9\u30A6\u30C9",
            en: "SaaS & Cloud"
        },
        stackDrone: {
            ja: "\u81EA\u793EAI\u30C9\u30ED\u30FC\u30F3",
            en: "AI Drone"
        },
        stackDroneSub: {
            ja: "\u30D7\u30ED\u30C0\u30AF\u30C8",
            en: "Product"
        },
        servicesLabel: {
            ja: "Services",
            en: "Services"
        },
        servicesTitle: {
            ja: "3\u3064\u306E\u67F1",
            en: "Three pillars"
        },
        servicesLead: {
            ja: "IT\u30FBAI\u3092\u4E0A\u4F4D\u6982\u5FF5\u3068\u3057\u3001\u6CD5\u4EBA\u5411\u3051\u5C0E\u5165\u652F\u63F4\u3068\u81EA\u793E\u30D7\u30ED\u30C0\u30AF\u30C8\u3092\u7D44\u307F\u5408\u308F\u305B\u3066\u63D0\u4F9B\u3057\u307E\u3059\u3002",
            en: "AI & IT at the center\u2014enterprise rollout plus our own product line."
        },
        questionsLabel: {
            ja: "\u3088\u304F\u3042\u308B\u554F\u3044",
            en: "Common questions"
        },
        questionsTitle: {
            ja: "\u6C17\u3065\u304B\u306A\u304B\u3063\u305F\u9055\u548C\u611F\u304B\u3089\u3001\u59CB\u3081\u307E\u305B\u3093\u304B\u3002",
            en: "Start from the friction you almost ignored."
        },
        featuredLabel: {
            ja: "\u5B9F\u7E3E",
            en: "Work"
        },
        featuredTitle: {
            ja: "\u5177\u4F53\u7684\u306A\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8",
            en: "Concrete outcomes"
        },
        featuredMore: {
            ja: "\u3059\u3079\u3066\u306E\u5B9F\u7E3E\u3092\u898B\u308B",
            en: "View all work"
        },
        insightsLabel: {
            ja: "Insights",
            en: "Insights"
        },
        insightsTitle: {
            ja: "\u30A4\u30F3\u30B5\u30A4\u30C8\u30FB\u30B3\u30E9\u30E0",
            en: "Insights & columns"
        },
        insightsLead: {
            ja: "AI\u5C0E\u5165\u3001\u30AF\u30E9\u30A6\u30C9\u3001\u30C9\u30ED\u30FC\u30F3\u2014\u2014\u73FE\u5834\u306E\u8996\u70B9\u3067\u767A\u4FE1\u3059\u308B\u6700\u65B0\u30B3\u30E9\u30E0\u3067\u3059\u3002",
            en: "Field notes on AI adoption, cloud, and drones\u2014from the NAPIRE bench."
        },
        insightsMore: {
            ja: "\u3059\u3079\u3066\u306E\u30B3\u30E9\u30E0\u3092\u898B\u308B",
            en: "View all insights"
        },
        insightsDateLabel: {
            ja: "\u516C\u958B\u65E5",
            en: "Published"
        },
        reportsLabel: {
            ja: "Reports",
            en: "Reports"
        },
        reportsTitle: {
            ja: "\u30B3\u30F3\u30B5\u30EB\u30C6\u30A3\u30F3\u30B0\u30EC\u30DD\u30FC\u30C8",
            en: "Consulting reports"
        },
        reportsLead: {
            ja: "\u696D\u754C\u52D5\u5411\u3084\u7279\u5B9A\u30C8\u30D4\u30C3\u30AF\u306B\u95A2\u3059\u308B\u5206\u6790\u30FB\u63D0\u8A00\u3092\u307E\u3068\u3081\u305F\u30EC\u30DD\u30FC\u30C8\u3067\u3059\u3002",
            en: "In-depth analysis and recommendations on industry trends and focused topics."
        },
        reportsMore: {
            ja: "\u3059\u3079\u3066\u306E\u30EC\u30DD\u30FC\u30C8\u3092\u898B\u308B",
            en: "View all reports"
        },
        aboutLabel: {
            ja: "About",
            en: "About"
        },
        aboutTitle: {
            ja: "AI\u30FBIT\u3067\u3001\u73FE\u5834\u304C\u5909\u308F\u308B\u3002",
            en: "Where AI & IT meet the floor."
        },
        aboutLead: {
            ja: "\u6CD5\u4EBA\u5411\u3051\u5C0E\u5165\u652F\u63F4\u3068\u81EA\u793E\u30D7\u30ED\u30C0\u30AF\u30C8\u3092\u8EF8\u306B\u3001\u8AB2\u984C\u306E\u8F2A\u90ED\u304B\u3089\u672C\u756A\u904B\u7528\u307E\u3067\u4E00\u6C17\u901A\u8CAB\u3067\u5C4A\u3051\u308B\u30C1\u30FC\u30E0\u3067\u3059\u3002",
            en: "Enterprise rollout and our own products\u2014one team from problem framing through production ops."
        },
        aboutCta: {
            ja: "\u4F1A\u793E\u6848\u5185\u30DA\u30FC\u30B8\u3078",
            en: "About NAPIRE"
        }
    },
    footer: {
        tagline: {
            ja: "AI\u30FBIT\u3067\u30D3\u30B8\u30CD\u30B9\u3068\u73FE\u5834\u3092\u3064\u306A\u3050\u3002",
            en: "Connecting business and the floor through AI & IT."
        },
        copyright: {
            ja: "\u682A\u5F0F\u4F1A\u793ENAPIRE",
            en: "NAPIRE Inc."
        }
    },
    pages: {
        breadcrumbHome: {
            ja: "\u30DB\u30FC\u30E0",
            en: "Home"
        },
        work: {
            pageTitle: {
                ja: "\u5B9F\u7E3E\u30FB\u4E8B\u4F8B | \u682A\u5F0F\u4F1A\u793ENAPIRE",
                en: "Work & Case Studies | NAPIRE Inc."
            },
            metaDescription: {
                ja: "NAPIRE\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u5B9F\u7E3E\u3002AI\u30FBDX\u3001\u30AF\u30E9\u30A6\u30C9\u3001\u30C9\u30ED\u30FC\u30F3\u306A\u3069\u5177\u4F53\u7684\u306A\u5C0E\u5165\u4E8B\u4F8B\u3092\u3054\u7D39\u4ECB\u3057\u307E\u3059\u3002",
                en: "NAPIRE project outcomes\u2014concrete case studies across AI/DX, cloud, and drones."
            },
            metaKeywords: {
                ja: "NAPIRE,\u5B9F\u7E3E,\u4E8B\u4F8B,AI\u5C0E\u5165,DX,\u30AF\u30E9\u30A6\u30C9,\u30C9\u30ED\u30FC\u30F3,\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8,\u6CD5\u4EBA\u5411\u3051",
                en: "NAPIRE,case studies,work,AI implementation,DX,cloud,drone,projects,enterprise"
            },
            heroLabel: {
                ja: "Work",
                en: "Work"
            },
            ctaTitle: {
                ja: "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u3054\u76F8\u8AC7",
                en: "Discuss a project"
            },
            ctaText: {
                ja: "\u985E\u4F3C\u6848\u4EF6\u306E\u9032\u3081\u65B9\u3082\u304A\u4F1D\u3048\u3067\u304D\u307E\u3059\u3002\u304A\u6C17\u8EFD\u306B\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002",
                en: "We can share how we'd approach similar engagements\u2014reach out anytime."
            },
            ctaBtn: {
                ja: "\u30E1\u30FC\u30EB\u3067\u76F8\u8AC7",
                en: "Email us"
            }
        },
        about: {
            pageTitle: {
                ja: "\u4F1A\u793E\u60C5\u5831 | \u682A\u5F0F\u4F1A\u793ENAPIRE",
                en: "About | NAPIRE Inc."
            },
            metaDescription: {
                ja: "\u682A\u5F0F\u4F1A\u793ENAPIRE\u306E\u4F1A\u793E\u6982\u8981\u3001\u30E1\u30F3\u30D0\u30FC\u4F53\u5236\u3001\u8003\u3048\u65B9\u3092\u3054\u7D39\u4ECB\u3057\u307E\u3059\u3002",
                en: "About NAPIRE\u2014company overview, team, and how we work."
            },
            metaKeywords: {
                ja: "NAPIRE,\u4F1A\u793E\u60C5\u5831,\u4F1A\u793E\u6982\u8981,AI\u4F01\u696D,IT\u4F01\u696D,\u6CD5\u4EBA\u5411\u3051,DX,\u30C1\u30FC\u30E0",
                en: "NAPIRE,about,company overview,AI company,IT company,enterprise,DX,team"
            },
            heroLabel: {
                ja: "About",
                en: "About"
            },
            heroTitle: {
                ja: "\u4F1A\u793E\u60C5\u5831",
                en: "About NAPIRE"
            },
            heroLead: {
                ja: "AI\u30FBIT\u3092\u8EF8\u306B\u3001\u6CD5\u4EBA\u5411\u3051\u5C0E\u5165\u652F\u63F4\u3068\u81EA\u793E\u30D7\u30ED\u30C0\u30AF\u30C8\u3092\u5C4A\u3051\u308B\u30C1\u30FC\u30E0\u3067\u3059\u3002",
                en: "An AI & IT team delivering enterprise rollouts and our own products."
            },
            overviewTitle: {
                ja: "\u4F1A\u793E\u6982\u8981",
                en: "Company overview"
            },
            thName: {
                ja: "\u4F1A\u793E\u540D",
                en: "Company"
            },
            thFounded: {
                ja: "\u8A2D\u7ACB",
                en: "Founded"
            },
            thPlace: {
                ja: "\u6240\u5728\u5730",
                en: "Location"
            },
            thBusiness: {
                ja: "\u4E8B\u696D\u5185\u5BB9",
                en: "Business"
            },
            thCapital: {
                ja: "\u8CC7\u672C\u91D1",
                en: "Capital"
            },
            teamCta: {
                ja: "\u30E1\u30F3\u30D0\u30FC\u7D39\u4ECB\u3092\u898B\u308B",
                en: "Meet the team"
            }
        },
        insights: {
            pageTitle: {
                ja: "\u30A4\u30F3\u30B5\u30A4\u30C8\u30FB\u30B3\u30E9\u30E0 | \u682A\u5F0F\u4F1A\u793ENAPIRE",
                en: "Insights | NAPIRE Inc."
            },
            metaDescription: {
                ja: "NAPIRE\u306E\u30A4\u30F3\u30B5\u30A4\u30C8\u30FB\u30B3\u30E9\u30E0\u3002AI\u5C0E\u5165\u3001\u30AF\u30E9\u30A6\u30C9\u3001\u30C9\u30ED\u30FC\u30F3\u306B\u95A2\u3059\u308B\u77E5\u898B\u3092\u767A\u4FE1\u3057\u307E\u3059\u3002",
                en: "NAPIRE insights and columns on AI adoption, cloud, and drones."
            },
            metaKeywords: {
                ja: "NAPIRE,\u30A4\u30F3\u30B5\u30A4\u30C8,\u30B3\u30E9\u30E0,AI\u5C0E\u5165,\u30AF\u30E9\u30A6\u30C9,\u30C9\u30ED\u30FC\u30F3,DX,\u6280\u8853\u30B3\u30E9\u30E0",
                en: "NAPIRE,insights,column,AI adoption,cloud,drone,DX,tech blog"
            },
            heroLabel: {
                ja: "Insights",
                en: "Insights"
            }
        },
        consultingReports: {
            pageTitle: {
                ja: "\u30B3\u30F3\u30B5\u30EB\u30C6\u30A3\u30F3\u30B0\u30EC\u30DD\u30FC\u30C8 | \u682A\u5F0F\u4F1A\u793ENAPIRE",
                en: "Consulting Reports | NAPIRE Inc."
            },
            metaDescription: {
                ja: "NAPIRE\u306E\u30B3\u30F3\u30B5\u30EB\u30C6\u30A3\u30F3\u30B0\u30EC\u30DD\u30FC\u30C8\u3002\u696D\u754C\u52D5\u5411\u3084\u7279\u5B9A\u30C8\u30D4\u30C3\u30AF\u306B\u95A2\u3059\u308B\u5206\u6790\u30FB\u63D0\u8A00\u3092\u63B2\u8F09\u3057\u307E\u3059\u3002",
                en: "NAPIRE consulting reports\u2014analysis and recommendations on industry trends and focused topics."
            },
            metaKeywords: {
                ja: "NAPIRE,\u30B3\u30F3\u30B5\u30EB\u30C6\u30A3\u30F3\u30B0\u30EC\u30DD\u30FC\u30C8,\u696D\u754C\u30EC\u30DD\u30FC\u30C8,AI\u5C0E\u5165,DX,\u30AF\u30E9\u30A6\u30C9,\u30C9\u30ED\u30FC\u30F3",
                en: "NAPIRE,consulting report,industry report,AI adoption,DX,cloud,drone"
            },
            heroLabel: {
                ja: "Reports",
                en: "Reports"
            }
        },
        contact: {
            pageTitle: {
                ja: "\u304A\u554F\u3044\u5408\u308F\u305B | \u682A\u5F0F\u4F1A\u793ENAPIRE",
                en: "Contact | NAPIRE Inc."
            },
            metaDescription: {
                ja: "\u682A\u5F0F\u4F1A\u793ENAPIRE\u3078\u306E\u304A\u554F\u3044\u5408\u308F\u305B\u30D5\u30A9\u30FC\u30E0\u3002AI\u30FBDX\u3001SaaS\u30FB\u30AF\u30E9\u30A6\u30C9\u3001\u81EA\u793EAI\u30C9\u30ED\u30FC\u30F3\u306A\u3069\u306E\u3054\u76F8\u8AC7\u306F\u3053\u3061\u3089\u304B\u3089\u3002",
                en: "Contact NAPIRE\u2014enterprise AI/DX, SaaS & cloud, and in-house AI drones."
            },
            metaKeywords: {
                ja: "NAPIRE,\u304A\u554F\u3044\u5408\u308F\u305B,\u76F8\u8AC7,AI\u5C0E\u5165,DX,SaaS,\u30AF\u30E9\u30A6\u30C9,AI\u30C9\u30ED\u30FC\u30F3,\u6CD5\u4EBA\u5411\u3051",
                en: "NAPIRE,contact,inquiry,AI implementation,DX,SaaS,cloud,AI drone,enterprise"
            },
            heroLabel: {
                ja: "Contact",
                en: "Contact"
            },
            heroTitle: {
                ja: "\u304A\u554F\u3044\u5408\u308F\u305B",
                en: "Contact us"
            },
            formNote: {
                ja: "\u3054\u5165\u529B\u3044\u305F\u3060\u3044\u305F\u5185\u5BB9\u306F\u62C5\u5F53\u3088\u308A\u3054\u9023\u7D61\u3044\u305F\u3057\u307E\u3059\u3002",
                en: "We'll get back to you after you submit the form."
            },
            selectedProductLabel: {
                ja: "\u898B\u7A4D\u5BFE\u8C61\u306E\u5546\u54C1",
                en: "Product for quotation"
            },
            selectedProductNote: {
                ja: "\u304A\u554F\u3044\u5408\u308F\u305B\u5185\u5BB9\u306B\u5546\u54C1\u540D\u3092\u5165\u529B\u3057\u305F\u72B6\u614B\u3067\u30D5\u30A9\u30FC\u30E0\u3092\u8868\u793A\u3057\u3066\u3044\u307E\u3059\u3002\u6570\u91CF\u30FB\u7D0D\u54C1\u5148\u30FB\u3054\u5E0C\u671B\u6642\u671F\u3092\u3054\u8A18\u5165\u304F\u3060\u3055\u3044\u3002",
                en: "The product name has been added to the inquiry. Please include quantity, delivery address, and preferred timing."
            }
        }
    },
    sectionHub: {
        heading: {
            ja: "\u30BB\u30AF\u30B7\u30E7\u30F3\u4E00\u89A7",
            en: "Sections"
        },
        lead: {
            ja: "\u30AB\u30FC\u30C9\u3092\u9078\u3076\u3068\u3001\u305D\u306E\u5185\u5BB9\u3092\u753B\u9762\u3044\u3063\u3071\u3044\u3067\u8868\u793A\u3057\u307E\u3059\u3002\u9589\u3058\u308B\u3068\u3053\u306E\u30DA\u30FC\u30B8\u306B\u623B\u308A\u307E\u3059\u3002",
            en: "Choose a card to view that section full screen. Close to return here."
        },
        close: {
            ja: "\u9589\u3058\u308B",
            en: "Close"
        }
    },
    scrollButtonText: {
        ja: "\u6C17\u306B\u306A\u308B\u3053\u3068\u3092\u9078\u3076",
        en: "Pick your question"
    },
    portal: {
        label: {
            ja: "NAPIRE / Portal",
            en: "NAPIRE / Portal"
        },
        heading: {
            ja: "\u4F55\u304C\u6C17\u306B\u306A\u308A\u307E\u3059\u304B\uFF1F",
            en: "What's on your mind?"
        },
        sub: {
            ja: "\u5F53\u793E\u306E\u77E5\u308A\u305F\u3044\u9805\u76EE\u3092\u9078\u3093\u3067\u304F\u3060\u3055\u3044\u3002\u9078\u3076\u3068\u3001NAPIRE\u306E\u7B54\u3048\u3068\u6B21\u306E\u30B9\u30C6\u30C3\u30D7\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002",
            en: "Pick what you want to explore\u2014we'll show how NAPIRE answers it and where to go next."
        },
        choices: [
            {
                id: "ai",
                label: {
                    ja: "AI\u3067\u4F55\u304C\u3067\u304D\u308B\u306E\uFF1F",
                    en: "What can AI actually do?"
                },
                answer: {
                    ja: "\u751F\u6210AI\u30FBRAG\u3001\u753B\u50CF\u8A8D\u8B58\u3001\u9700\u8981\u4E88\u6E2C\u2014\u2014\u8AB2\u984C\u306B\u5408\u308F\u305B\u3066\u9078\u3073\u3001PoC\u3067\u7D42\u308F\u3089\u305B\u305A\u672C\u756A\u307E\u3067\u4F34\u8D70\u3057\u307E\u3059\u3002\u81EA\u793E\u30C9\u30ED\u30FC\u30F3\u3067\u57F9\u3063\u305F\u5B9F\u88C5\u529B\u304C\u3001\u6CD5\u4EBA\u306EAI\u5C0E\u5165\u306B\u3082\u6D3B\u304D\u307E\u3059\u3002",
                    en: "GenAI/RAG, vision, forecasting\u2014scoped to your problem, shipped past the PoC deck. The same build discipline we use on our drones, applied to your enterprise AI."
                },
                cta: {
                    ja: "AI\u30FBDX\u5C0E\u5165\u652F\u63F4\u3092\u898B\u308B",
                    en: "Explore AI & DX"
                },
                target: "ai-dx.html"
            },
            {
                id: "cloud",
                label: {
                    ja: "SaaS\u30FB\u30AF\u30E9\u30A6\u30C9\u3001\u4F55\u304B\u3089\u59CB\u3081\u308B\uFF1F",
                    en: "SaaS & cloud\u2014where do we start?"
                },
                answer: {
                    ja: "Microsoft 365\u30FBGoogle Workspace\u3001SaaS\u30FBAI\u30FB\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30FB\u30AF\u30E9\u30A6\u30C9\u88FD\u54C1\u306E\u4ED5\u5165\u308C\u304B\u3089\u79FB\u884C\u30FB\u5B9A\u7740\u307E\u3067\u3002\u30E9\u30A4\u30BB\u30F3\u30B9\u5951\u7D04\u3067\u7D42\u308F\u3089\u305B\u305A\u3001AI\u9023\u643A\u3092\u898B\u636E\u3048\u305F\u30C7\u30FC\u30BF\u57FA\u76E4\u307E\u3067\u8A2D\u8A08\u3057\u307E\u3059\u3002",
                    en: "From procurement of M365, Google Workspace, SaaS, AI, security, and cloud\u2014through migration, adoption, and data foundations ready for AI. Not just licenses."
                },
                cta: {
                    ja: "SaaS\u30FB\u30AF\u30E9\u30A6\u30C9\u5C0E\u5165\u652F\u63F4\u3092\u898B\u308B",
                    en: "Explore SaaS & cloud"
                },
                target: "saas-cloud.html"
            },
            {
                id: "poc",
                label: {
                    ja: "PoC\u306F\u6210\u529F\u3057\u305F\u306E\u306B\u672C\u756A\u306B\u4E57\u3089\u306A\u3044",
                    en: "PoC worked\u2014production didn't"
                },
                answer: {
                    ja: "\u30C7\u30FC\u30BF\u54C1\u8CEA\u30FB\u6A29\u9650\u30FBMLOps\u3092\u6700\u521D\u304B\u3089\u7E54\u308A\u8FBC\u3080\u306E\u304C\u79C1\u305F\u3061\u306E\u6A19\u6E96\u3067\u3059\u3002\u30B3\u30F3\u30B5\u30EB\u3067\u7D42\u308F\u3089\u305A\u3001\u30B3\u30FC\u30C9\u304C\u52D5\u304F\u3068\u3053\u308D\u307E\u3067\u540C\u3058\u30C1\u30FC\u30E0\u304C\u8CAC\u4EFB\u3092\u6301\u3061\u307E\u3059\u3002",
                    en: "We weave data quality, access, and MLOps in from day one\u2014one squad from framing through production code."
                },
                cta: {
                    ja: "\u5B9F\u7E3E\u3092\u898B\u308B",
                    en: "See our work"
                },
                target: "#proof"
            },
            {
                id: "drone",
                label: {
                    ja: "\u81EA\u793E\u30C9\u30ED\u30FC\u30F3\u3063\u3066\u4F55\u304C\u9055\u3046\uFF1F",
                    en: "What's different about your drones?"
                },
                answer: {
                    ja: "\u30AD\u30C3\u30C8\u3092\u7D44\u3080\u306E\u3067\u306F\u306A\u304F\u3001\u7528\u9014\u304B\u3089\u6A5F\u4F53\u30FB\u63A8\u529B\u30FB\u30BB\u30F3\u30B5\u3092\u8A2D\u8A08\u3002\u3060\u304B\u3089\u98DB\u884C\u5236\u5FA1\u3082\u8A8D\u8B58AI\u3082\u300C\u3053\u306E\u6A5F\u4F53\u306E\u305F\u3081\u306E\u300D\u30B3\u30FC\u30C9\u3060\u3051\u304C\u66F8\u3051\u307E\u3059\u3002",
                    en: "We don't assemble kits\u2014we size frames, thrust, and sensors for the mission. Flight and perception are authored for this airframe only."
                },
                cta: {
                    ja: "\u30C9\u30ED\u30FC\u30F3\u3092\u898B\u308B",
                    en: "Explore drones"
                },
                target: "#drone"
            },
            {
                id: "team",
                label: {
                    ja: "\u3069\u3093\u306A\u30C1\u30FC\u30E0\u304C\u5165\u308B\u306E\uFF1F",
                    en: "Who actually shows up?"
                },
                answer: {
                    ja: "AI\u30B9\u30C8\u30E9\u30C6\u30B8\u30FC\u3001\u30D5\u30EB\u30B9\u30BF\u30C3\u30AF\u3001\u30AF\u30E9\u30A6\u30C9\u3001\u7D44\u307F\u8FBC\u307F\u2014\u2014\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u5FC5\u8981\u306A\u5F79\u5272\u3054\u3068\u306B\u3001\u8A2D\u8A08\u304B\u3089\u5B9F\u88C5\u307E\u3067\u5165\u308A\u307E\u3059\u3002",
                    en: "Strategy, full-stack, cloud, embedded\u2014the roles your project needs, from design through build."
                },
                cta: {
                    ja: "\u4F53\u5236\u3092\u898B\u308B",
                    en: "Meet the roles"
                },
                target: "#team"
            },
            {
                id: "talk",
                label: {
                    ja: "\u307E\u305A\u8A71\u3092\u805E\u3044\u3066\u307F\u305F\u3044",
                    en: "I just want to talk first"
                },
                answer: {
                    ja: "\u8CC7\u6599\u306F\u4E0D\u8981\u3067\u3059\u3002\u30AA\u30F3\u30E9\u30A4\u30F3\u306730\u5206\u3001\u8AB2\u984C\u306E\u8F2A\u90ED\u304B\u3089\u304A\u805E\u304B\u305B\u304F\u3060\u3055\u3044\u3002",
                    en: "No deck required\u2014book 30 minutes and tell us where you are."
                },
                cta: {
                    ja: "\u76F8\u8AC7\u3059\u308B",
                    en: "Get in touch"
                },
                target: "contact.html"
            }
        ]
    },
    hero: {
        eyebrow: {
            ja: "\u682A\u5F0F\u4F1A\u793ENAPIRE\uFF08\u30CD\u30A4\u30D4\u30A2\uFF09",
            en: "NAPIRE Inc."
        },
        line1: {
            ja: "Connecting",
            en: "Connecting"
        },
        line2: {
            ja: "Business",
            en: "Business"
        },
        line3: {
            ja: "& AI",
            en: "& AI"
        },
        ribbon: {
            ja: "\u30C9\u30ED\u30FC\u30F3\u306F\u3001\u4ED5\u5165\u308C\u305F\u30AD\u30C3\u30C8\u3092\u4E26\u3079\u308B\u3060\u3051\u3067\u306F\u306A\u304F\u3001\u73FE\u5834\u306E\u8A71\u304B\u3089\u6A5F\u4F53\u3092\u8D77\u3053\u3057\u3066\u3044\u307E\u3059\u3002\u63A8\u529B\u3084\u30BB\u30F3\u30B5\u304C\u898B\u3048\u3066\u304B\u3089\u30B3\u30FC\u30C9\u3092\u66F8\u304F\u2014\u2014\u305D\u306E\u9806\u756A\u3092\u3001\u79C1\u305F\u3061\u306F\u5927\u5207\u306B\u3057\u3066\u3044\u307E\u3059\u3002",
            en: "We grow our drones out of field conversations, not a shopping list of parts\u2014and we only start writing software once the airframe story feels honest."
        },
        lead: {
            ja: "AI\u4F01\u696D\u3068\u3057\u3066\u3001\u6CD5\u4EBA\u5411\u3051AI\u30FBDX\u5C0E\u5165\u652F\u63F4\u3068SaaS\u30FB\u30AF\u30E9\u30A6\u30C9\u5C0E\u5165\u652F\u63F4\u306B\u52A0\u3048\u3001\u81EA\u793EAI\u30C9\u30ED\u30FC\u30F3\u3092\u6A5F\u4F53\u304B\u3089\u8A2D\u8A08\u3002\u30CF\u30FC\u30C9\u3068\u30BD\u30D5\u30C8\u3092\u540C\u3058\u30C1\u30FC\u30E0\u3067\u63E1\u308B\u304B\u3089\u3053\u305D\u3001\u73FE\u5834\u3067\u52D5\u304FAI\u3092\u5C4A\u3051\u307E\u3059\u3002",
            en: "As an AI company, we deliver enterprise AI/DX and SaaS/cloud rollouts\u2014plus in-house drones built from the airframe up. One team owns hardware and software, so AI survives contact with the real world."
        },
        scrollHint: {
            ja: "SCROLL",
            en: "SCROLL"
        },
        sideLabel: {
            ja: "AI COMPANY \xd7 DRONE \xd7 CLOUD",
            en: "AI COMPANY \xd7 DRONE \xd7 CLOUD"
        },
        bootLines: {
            ja: [
                "system.init() \u2014 NAPIRE AI LAB",
                "loading modules: gen_ai, cv, mlops, edge...",
                "status: ready to connect business & AI"
            ],
            en: [
                "system.init() \u2014 NAPIRE AI LAB",
                "loading modules: gen_ai, cv, mlops, edge...",
                "status: ready to connect business & AI"
            ]
        }
    },
    story: {
        eyebrow: {
            ja: "\u3042\u306A\u305F\u306E\u96A3\u3067\u3001\u8003\u3048\u308B",
            en: "Questions at your side"
        },
        heading: {
            ja: "\u6C17\u3065\u304B\u306A\u304B\u3063\u305F\u554F\u3044\u304C\u3001DX\u306E\u5165\u53E3\u306B\u306A\u308B\u3002",
            en: "The question you skipped is where DX starts."
        },
        lead: {
            ja: "\u660E\u96FB\u820E\u306E\u300C\u3042\u306A\u305F\u306E\u96A3\u3067\u300D\u304C\u793A\u3059\u3088\u3046\u306B\u3001\u3044\u304D\u306A\u308A\u6280\u8853\u3092\u8A9E\u308B\u306E\u3067\u306F\u306A\u304F\u3001\u73FE\u5834\u306E\u9055\u548C\u611F\u304B\u3089\u5165\u308B\u3002NAPIRE\u3082\u540C\u3058\u3067\u3059\u3002",
            en: "Like Meidensha's 'at your side' approach\u2014we don't open with specs. We start with the friction your floor already feels."
        },
        questions: [
            {
                q: {
                    ja: "AI\u3092\u5C0E\u5165\u3057\u305F\u306E\u306B\u3001\u8AB0\u3082\u4F7F\u3063\u3066\u3044\u306A\u3044\u2014\u2014\u305D\u308C\u3001\u672C\u5F53\u306B\u5C0E\u5165\u3067\u3059\u304B\uFF1F",
                    en: "You 'deployed' AI\u2014nobody uses it. Was that really deployment?"
                },
                bridge: {
                    ja: "\u2192 \u30E6\u30FC\u30B9\u30B1\u30FC\u30B9\u8A2D\u8A08\u3068\u5B9A\u7740\u652F\u63F4\u307E\u3067\u3001NAPIRE\u304C\u4F34\u8D70\u3057\u307E\u3059\u3002",
                    en: "\u2192 NAPIRE partners through use-case design and adoption\u2014not just licenses."
                }
            },
            {
                q: {
                    ja: "PoC\u306F\u6210\u529F\u3057\u305F\u3002\u3067\u3082\u672C\u756A\u306B\u4E57\u3089\u306A\u3044\u2014\u2014\u4F55\u304C\u8DB3\u308A\u306A\u304B\u3063\u305F\uFF1F",
                    en: "The PoC worked. Production didn't. What was missing?"
                },
                bridge: {
                    ja: "\u2192 \u30C7\u30FC\u30BF\u54C1\u8CEA\u30FB\u6A29\u9650\u30FBMLOps\u3092\u6700\u521D\u304B\u3089\u7E54\u308A\u8FBC\u3080\u5B9F\u88C5\u529B\u304C\u3042\u308A\u307E\u3059\u3002",
                    en: "\u2192 We weave data quality, access, and MLOps in from day one."
                }
            },
            {
                q: {
                    ja: "SaaS\u30FBAI\u30FB\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u88FD\u54C1\u3092\u307E\u3068\u3081\u3066\u4ED5\u5165\u308C\u305F\u3044\u2014\u2014\u3069\u3053\u304B\u3089\uFF1F",
                    en: "We need SaaS, AI, and security products\u2014where do we start?"
                },
                bridge: {
                    ja: "\u2192 M365\u30FBGWS\u3001SaaS\u30FBAI\u30FB\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30FB\u30AF\u30E9\u30A6\u30C9\u88FD\u54C1\u306E\u4ED5\u5165\u308C\u304B\u3089\u5C0E\u5165\u30FB\u5B9A\u7740\u307E\u3067\u4E00\u62EC\u3067\u652F\u63F4\u3057\u307E\u3059\u3002",
                    en: "\u2192 Procurement for M365, GWS, SaaS, AI, security, and cloud\u2014through rollout and adoption."
                }
            }
        ],
        cta: {
            ja: "\u3042\u306A\u305F\u306E\u554F\u3044\u3092\u805E\u304B\u305B\u3066\u304F\u3060\u3055\u3044",
            en: "Tell us your question"
        }
    },
    solutions: {
        eyebrow: {
            ja: "\u6CD5\u4EBA\u5411\u3051\u30BD\u30EA\u30E5\u30FC\u30B7\u30E7\u30F3",
            en: "Enterprise solutions"
        },
        heading: {
            ja: "\u5C0E\u5165\u3057\u3066\u3001\u4F7F\u308F\u308C\u308B\u307E\u3067\u3002",
            en: "Ship it\u2014and make it stick."
        },
        lead: {
            ja: "FBJ\u3084Woodrow\u306E\u3088\u3046\u306A\u5C0E\u5165\u652F\u63F4\u306E\u77E5\u898B\u3092\u6D3B\u304B\u3057\u3064\u3064\u3001AI\u4F01\u696D\u306A\u3089\u3067\u306F\u306E\u5B9F\u88C5\u529B\u3067\u672C\u756A\u307E\u3067\u4F34\u8D70\u3057\u307E\u3059\u3002",
            en: "Enterprise rollout discipline\u2014plus an AI builder's instinct for what survives production."
        },
        aiDx: {
            tag: {
                ja: "Enterprise AI / DX",
                en: "Enterprise AI / DX"
            },
            title: {
                ja: "\u6CD5\u4EBA\u5411\u3051AI\u30FBDX\u5C0E\u5165\u652F\u63F4",
                en: "Enterprise AI & DX"
            },
            desc: {
                ja: "\u751F\u6210AI\u30FBRAG\u3001Computer Vision\u3001\u9700\u8981\u4E88\u6E2C\u304B\u3089\u30C7\u30FC\u30BF\u57FA\u76E4\u30FBMLOps\u307E\u3067\u3002PoC\u3067\u7D42\u308F\u3089\u305B\u306A\u3044\u3002",
                en: "GenAI/RAG, vision, forecasting, data platforms, MLOps\u2014beyond the PoC deck."
            },
            cta: {
                ja: "\u8A73\u3057\u304F\u898B\u308B",
                en: "Learn more"
            },
            href: "ai-dx.html"
        },
        saasCloud: {
            tag: {
                ja: "SaaS / Cloud",
                en: "SaaS / Cloud"
            },
            title: {
                ja: "SaaS\u30FB\u30AF\u30E9\u30A6\u30C9\u5C0E\u5165\u652F\u63F4",
                en: "SaaS & cloud rollout"
            },
            desc: {
                ja: "M365\u30FBGWS\u3001SaaS\u30FBAI\u30FB\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30FB\u30AF\u30E9\u30A6\u30C9\u88FD\u54C1\u306E\u4ED5\u5165\u308C\u304B\u3089\u79FB\u884C\u30FB\u5B9A\u7740\u307E\u3067\u4E00\u6C17\u901A\u8CAB\u3002",
                en: "Procurement for M365, GWS, SaaS, AI, security, and cloud\u2014through migration and adoption."
            },
            cta: {
                ja: "\u8A73\u3057\u304F\u898B\u308B",
                en: "Learn more"
            },
            href: "saas-cloud.html"
        }
    },
    insights: {
        eyebrow: {
            ja: "Insights / Column",
            en: "Insights / Column"
        },
        heading: {
            ja: "AI\u3068\u73FE\u5834\u306E\u3042\u3044\u3060",
            en: "Between AI and the floor"
        },
        lead: {
            ja: "\u5C0E\u5165\u306E\u73FE\u5834\u3067\u898B\u3048\u3066\u304D\u305F\u3053\u3068\u3001\u6280\u8853\u9078\u5B9A\u306E\u5224\u65AD\u8EF8\u3001\u5931\u6557\u304B\u3089\u5B66\u3093\u3060\u3053\u3068\u2014\u2014NAPIRE\u306E\u8996\u70B9\u3092\u767A\u4FE1\u3057\u3066\u3044\u304D\u307E\u3059\u3002",
            en: "Field notes, selection heuristics, lessons from what didn't work\u2014perspectives from the NAPIRE bench."
        },
        articles: [
            {
                tag: {
                    ja: "\u751F\u6210AI",
                    en: "GenAI"
                },
                title: {
                    ja: "RAG\u3092\u672C\u756A\u3067\u56DE\u3059\u305F\u3081\u306B\u3001\u6700\u521D\u306B\u6C7A\u3081\u308B\u3079\u304D5\u3064\u306E\u3053\u3068",
                    en: "Five decisions before RAG hits production"
                },
                desc: {
                    ja: "\u691C\u7D22\u7CBE\u5EA6\u3060\u3051\u3067\u306A\u304F\u3001\u6A29\u9650\u30FB\u30B3\u30B9\u30C8\u30FB\u8A55\u4FA1\u6307\u6A19\u3092\u3069\u3046\u8A2D\u8A08\u3059\u308B\u304B\u3002",
                    en: "Beyond retrieval accuracy\u2014access, cost, and evaluation from the start."
                },
                date: {
                    ja: "2025.08",
                    en: "Aug 2025"
                }
            },
            {
                tag: {
                    ja: "\u30AF\u30E9\u30A6\u30C9",
                    en: "Cloud"
                },
                title: {
                    ja: "M365\u5C0E\u5165\u3067\u300C\u4F7F\u308F\u308C\u308B\u300D\u74B0\u5883\u3092\u3064\u304F\u308B3\u3064\u306E\u30DD\u30A4\u30F3\u30C8",
                    en: "Three patterns for M365 that actually gets used"
                },
                desc: {
                    ja: "\u30E9\u30A4\u30BB\u30F3\u30B9\u5951\u7D04\u3067\u7D42\u308F\u3089\u305B\u306A\u3044\u3002\u696D\u52D9\u30D5\u30ED\u30FC\u3068\u7814\u4FEE\u8A2D\u8A08\u306E\u8A71\u3002",
                    en: "Licenses aren't the finish line\u2014workflows and training design are."
                },
                date: {
                    ja: "2025.07",
                    en: "Jul 2025"
                }
            },
            {
                tag: {
                    ja: "\u30C9\u30ED\u30FC\u30F3 \xd7 AI",
                    en: "Drone \xd7 AI"
                },
                title: {
                    ja: "\u6A5F\u4F53\u3092\u81EA\u793E\u3067\u8A2D\u8A08\u3059\u308B\u3068\u3001AI\u306E\u7CBE\u5EA6\u304C\u5909\u308F\u308B\u7406\u7531",
                    en: "Why owning the airframe changes your AI accuracy"
                },
                desc: {
                    ja: "\u30AB\u30E1\u30E9\u306E\u9732\u51FA\u30FB\u632F\u52D5\u30FBFPS\u2014\u2014\u30CF\u30FC\u30C9\u5236\u7D04\u304C\u30E2\u30C7\u30EB\u8A2D\u8A08\u3092\u6C7A\u3081\u308B\u3002",
                    en: "Exposure, vibration, FPS\u2014hardware constraints that shape your models."
                },
                date: {
                    ja: "2025.06",
                    en: "Jun 2025"
                }
            }
        ],
        comingSoon: {
            ja: "\u8A18\u4E8B\u3092\u6E96\u5099\u4E2D\u3067\u3059\u3002\u3057\u3070\u3089\u304F\u304A\u5F85\u3061\u304F\u3060\u3055\u3044\u3002",
            en: "Articles are on the way\u2014please check back soon."
        }
    },
    consultingReports: {
        eyebrow: {
            ja: "Consulting Reports",
            en: "Consulting Reports"
        },
        heading: {
            ja: "\u696D\u754C\u3068\u30C8\u30D4\u30C3\u30AF\u3092\u8AAD\u307F\u89E3\u304F",
            en: "Reading industries and topics"
        },
        lead: {
            ja: "\u7279\u5B9A\u306E\u696D\u754C\u30FB\u30C6\u30FC\u30DE\u306B\u5BFE\u3059\u308B\u5206\u6790\u3068\u63D0\u8A00\u3092\u3001\u30B3\u30F3\u30B5\u30EB\u30C6\u30A3\u30F3\u30B0\u30EC\u30DD\u30FC\u30C8\u3068\u3057\u3066\u516C\u958B\u3057\u3066\u3044\u304D\u307E\u3059\u3002",
            en: "We publish structured analysis and recommendations on specific industries and themes."
        },
        comingSoon: {
            ja: "\u30EC\u30DD\u30FC\u30C8\u3092\u6E96\u5099\u4E2D\u3067\u3059\u3002\u3057\u3070\u3089\u304F\u304A\u5F85\u3061\u304F\u3060\u3055\u3044\u3002",
            en: "Reports are on the way\u2014please check back soon."
        }
    },
    reportDownload: {
        pageLabel: {
            ja: "\u30DA\u30FC\u30B8",
            en: "Page"
        },
        lockedLabel: {
            ja: "\u6570\u5024\u30FB\u8A73\u7D30\u306F\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3067\u3054\u89A7\u304F\u3060\u3055\u3044",
            en: "Numbers and details are in the download"
        },
        teaserLabel: {
            ja: "\u56F3\u8868\u306E\u8A73\u7D30\u30FB\u5168\u6587\u306F\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3067",
            en: "Full charts and text are in the download"
        },
        lockedCta: {
            ja: "\u5168\u6587\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
            en: "Download full PDF"
        },
        formEyebrow: {
            ja: "Download",
            en: "Download"
        },
        formTitle: {
            ja: "\u30EC\u30DD\u30FC\u30C8\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
            en: "Download the report"
        },
        formLead: {
            ja: "\u304A\u540D\u524D\u30FB\u4F1A\u793E\u540D\u30FB\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u3054\u5165\u529B\u304F\u3060\u3055\u3044\u3002\u9001\u4FE1\u5F8C\u3001PDF\u306E\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u304C\u59CB\u307E\u308A\u307E\u3059\u3002",
            en: "Enter your name, company, and email. The PDF download will start after you submit."
        },
        labelName: {
            ja: "\u304A\u540D\u524D",
            en: "Name"
        },
        labelCompany: {
            ja: "\u4F1A\u793E\u540D",
            en: "Company"
        },
        labelEmail: {
            ja: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
            en: "Email"
        },
        placeholderName: {
            ja: "\u5C71\u7530 \u592A\u90CE",
            en: "Jane Doe"
        },
        placeholderCompany: {
            ja: "\u682A\u5F0F\u4F1A\u793E\u30B5\u30F3\u30D7\u30EB",
            en: "Acme Inc."
        },
        placeholderEmail: {
            ja: "you@example.com",
            en: "you@example.com"
        },
        consentLabel: {
            ja: "\u500B\u4EBA\u60C5\u5831\u306E\u53D6\u6271\u3044\u306B\u540C\u610F\u306E\u3046\u3048\u3001\u30EC\u30DD\u30FC\u30C8\u3092\u53D7\u3051\u53D6\u308A\u307E\u3059\u3002",
            en: "I agree to the handling of my personal information and wish to receive the report."
        },
        submit: {
            ja: "PDF\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
            en: "Download PDF"
        },
        submitting: {
            ja: "\u9001\u4FE1\u4E2D\u2026",
            en: "Submitting\u2026"
        },
        success: {
            ja: "\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3092\u958B\u59CB\u3057\u307E\u3057\u305F\u3002\u5225\u30BF\u30D6\u304C\u958B\u304B\u306A\u3044\u5834\u5408\u306F\u30DD\u30C3\u30D7\u30A2\u30C3\u30D7\u3092\u8A31\u53EF\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            en: "Download started. Allow pop-ups if a new tab did not open."
        },
        successNewTab: {
            ja: "\u65B0\u3057\u3044\u30BF\u30D6\u3067\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3092\u958B\u59CB\u3057\u307E\u3059\u3002\u30BF\u30D6\u304C\u958B\u304B\u306A\u3044\u5834\u5408\u306F\u30DD\u30C3\u30D7\u30A2\u30C3\u30D7\u3092\u8A31\u53EF\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            en: "Starting download in a new tab. Allow pop-ups if it did not open."
        },
        popupBlocked: {
            ja: "\u30DD\u30C3\u30D7\u30A2\u30C3\u30D7\u304C\u30D6\u30ED\u30C3\u30AF\u3055\u308C\u307E\u3057\u305F\u3002\u30D6\u30E9\u30A6\u30B6\u3067\u8A31\u53EF\u3057\u3066\u304B\u3089\u518D\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
            en: "Pop-up blocked. Allow pop-ups for this site and try again."
        },
        failed: {
            ja: "\u9001\u4FE1\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u6642\u9593\u3092\u304A\u3044\u3066\u518D\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
            en: "Something went wrong. Please try again in a moment."
        },
        notConfigured: {
            ja: "\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u53D7\u4ED8\u306E\u6E96\u5099\u4E2D\u3067\u3059\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
            en: "Downloads are being set up. Please try again shortly."
        },
        consentRequired: {
            ja: "\u500B\u4EBA\u60C5\u5831\u306E\u53D6\u6271\u3044\u3078\u306E\u540C\u610F\u304C\u5FC5\u8981\u3067\u3059\u3002",
            en: "Please agree to the handling of personal information."
        },
        missingFields: {
            ja: "\u5FC5\u9808\u9805\u76EE\u3092\u3059\u3079\u3066\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            en: "Please fill in all required fields."
        },
        invalidEmail: {
            ja: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u5F62\u5F0F\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002",
            en: "Please check the email address format."
        }
    },
    marquee: {
        items: {
            ja: [
                "\u81EA\u793E\u30C9\u30ED\u30FC\u30F3",
                "\u6A5F\u4F53\u8A2D\u8A08",
                "\u30E2\u30B8\u30E5\u30FC\u30EB\u642D\u8F09",
                "\u81EA\u5F8B\u98DB\u884C",
                "\u30A8\u30C3\u30B8\u63A8\u8AD6",
                "\u751F\u6210AI",
                "RAG",
                "\u30C7\u30FC\u30BF\u57FA\u76E4",
                "MLOps",
                "\u4E0A\u6D41\u8A2D\u8A08",
                "Computer Vision",
                "OCR",
                "\u9700\u8981\u4E88\u6E2C",
                "\u30D5\u30EB\u30B9\u30BF\u30C3\u30AF\u958B\u767A",
                "AWS / GCP / Azure",
                "\u30D7\u30ED\u30C0\u30AF\u30C8\u601D\u8003"
            ],
            en: [
                "In-house drones",
                "Airframe design",
                "Modular payloads",
                "Autonomous flight",
                "Edge inference",
                "GenAI",
                "RAG",
                "Data platforms",
                "MLOps",
                "Discovery",
                "Computer vision",
                "OCR",
                "Forecasting",
                "Full-stack build",
                "AWS / GCP / Azure",
                "Product mindset"
            ]
        }
    },
    statement: {
        mega: {
            ja: "AI\u30FBDX\u3001\u30AF\u30E9\u30A6\u30C9\u3001\u30D7\u30ED\u30C0\u30AF\u30C8\u2014\u2014\u4E09\u3064\u306E\u67F1\u3067\u5C4A\u3051\u308B\u3002",
            en: "AI & DX, cloud, and product\u2014delivered as three pillars."
        },
        sub: {
            ja: "\u6CD5\u4EBA\u5411\u3051AI\u30FBDX\u5C0E\u5165\u3001SaaS\u30FB\u30AF\u30E9\u30A6\u30C9\u306E\u7ACB\u3061\u4E0A\u3052\u3001\u81EA\u793EAI\u30C9\u30ED\u30FC\u30F3\u306E\u958B\u767A\u3002\u3044\u305A\u308C\u3082\u8AB2\u984C\u306E\u6574\u7406\u304B\u3089\u5B9F\u88C5\u30FB\u691C\u8A3C\u30FB\u904B\u7528\u307E\u3067\u3001\u540C\u3058\u30C1\u30FC\u30E0\u304C\u672C\u756A\u307E\u3067\u8CAC\u4EFB\u3092\u6301\u3063\u3066\u4F34\u8D70\u3057\u307E\u3059\u3002",
            en: "Enterprise AI & DX, SaaS & cloud rollout, and in-house AI drones\u2014from scoping through build, validation, and ops, one accountable team through production."
        }
    },
    drone: {
        sideways: {
            ja: "PRODUCT",
            en: "PRODUCT"
        },
        eyebrow: {
            ja: "Flagship \uFF0F \u81EA\u793E\u30D7\u30ED\u30C0\u30AF\u30C8",
            en: "Flagship \uFF0F In-house product"
        },
        title: {
            ja: "\u30C9\u30ED\u30FC\u30F3\u306F\u3001\u767D\u7D19\u306E\u6A5F\u4F53\u304B\u3089\u3002",
            en: "Drones from a blank airframe."
        },
        lead: {
            ja: "\u30AD\u30C3\u30C8\u3092\u7D44\u3080\u306E\u3067\u306F\u306A\u304F\u3001\u7528\u9014\u304B\u3089\u6A5F\u4F53\u30B5\u30A4\u30BA\u30FB\u63A8\u529B\u30FB\u30BB\u30F3\u30B5\u69CB\u6210\u3092\u6C7A\u3081\u3001\u30E2\u30B8\u30E5\u30FC\u30EB\u3092\u8F09\u305B\u5207\u308B\u3068\u3053\u308D\u307E\u3067\u81EA\u793E\u3067\u63E1\u308A\u307E\u3059\u3002\u3060\u304B\u3089\u3053\u305D\u3001\u98DB\u884C\u5236\u5FA1\u304B\u3089\u8A8D\u8B58AI\u307E\u3067\u300C\u3053\u306E\u6A5F\u4F53\u306E\u305F\u3081\u306E\u300D\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3060\u3051\u304C\u66F8\u3051\u308B\u3002",
            en: "We don't stop at off-the-shelf kits\u2014we size the frame, thrust, and sensor stack for the mission, integrate modules, and own the stack end to end. That's why flight, failsafes, and perception are authored for this airframe\u2014not a generic SDK demo."
        },
        hardwareHeading: {
            ja: "\u30CF\u30FC\u30C9\u30A6\u30A7\u30A2\uFF08\u6A5F\u4F53\u30FB\u30E2\u30B8\u30E5\u30FC\u30EB\uFF09",
            en: "Hardware \u2014 airframe & modules"
        },
        hardwareBody: {
            ja: "\u6A5F\u4F53\u9078\u5B9A\u301C\u30AB\u30B9\u30BF\u30E0\u30D5\u30EC\u30FC\u30E0\u3001\u30D7\u30ED\u30DA\u30E9\u3001ESC\u3001\u30D0\u30C3\u30C6\u30EA\u30FC\u3001\u5404\u7A2E\u30BB\u30F3\u30B5\u306E\u30DE\u30A6\u30F3\u30C8\u307E\u3067\u3092\u4E00\u3064\u306E\u8A2D\u8A08\u3068\u3057\u3066\u9032\u884C\u3002\u73FE\u5834\u306E\u98A8\u30FB\u9AD8\u5EA6\u30FB\u822A\u7D9A\u3067\u9006\u7B97\u3057\u307E\u3059\u3002",
            en: "We run selection or custom frames, propulsion, ESCs, power budgets, and physical sensor mounts as one system\u2014traded against wind, altitude, and endurance your field actually sees."
        },
        hardwareBullets: {
            ja: [
                "\u6A5F\u4F53\u30FB\u63A8\u529B\u30FB\u91CD\u91CF\u30D0\u30E9\u30F3\u30B9\u3092\u7528\u9014\u304B\u3089\u8A2D\u8A08\u3057\u3001\u5FC5\u8981\u306A\u3089\u5C0F\u578B\u301C\u4E2D\u578B\u30AF\u30E9\u30B9\u307E\u3067\u8ABF\u9054\u30FB\u5B9F\u88C5\u3092\u7D71\u5408",
                "\u30AB\u30E1\u30E9\uFF0F\u6DF1\u5EA6\uFF0FGNSS \u7B49\u306E\u642D\u8F09\u4F4D\u7F6E\u3068\u914D\u7DDA\u307E\u3067\u542B\u3081\u3066\u6C7A\u5B9A\u3057\u3001\u632F\u52D5\u30FB\u30DB\u30EF\u30A4\u30C8\u30D0\u30E9\u30F3\u30B9\u7B49\u306E\u5B9F\u6A5F\u5236\u7D04\u3092\u5148\u306B\u53D6\u308A\u8FBC\u3080",
                "\u300C\u98DB\u3070\u3059\u300D\u3060\u3051\u3067\u306A\u304F\u3001\u70B9\u691C\u30FB\u4EA4\u63DB\u30FB\u73FE\u5834\u904B\u7528\u3092\u898B\u636E\u3048\u305F\u30E2\u30B8\u30E5\u30FC\u30EB\u69CB\u6210"
            ],
            en: [
                "Frame and thrust budgets sized from mission profiles\u2014integrating procurement and build from small to mid-sized classes when needed",
                "Camera, depth, GNSS placement, wiring, and vibration budgets locked early\u2014not patched after the fact",
                "Layouts meant for field maintenance, swaps, and operator workflows\u2014not one-off demos"
            ]
        },
        bridge: {
            ja: "\u6A5F\u4F53\u30FB\u63A8\u9032\u30FB\u30BB\u30F3\u30B5\u3092\u81EA\u793E\u3067\u8A2D\u8A08\u3057\u3066\u3044\u308B\u304B\u3089",
            en: "Because we own the airframe, propulsion, and sensors"
        },
        softwareHeading: {
            ja: "\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\uFF08\u5236\u5FA1\u30FB\u8A8D\u8B58\u30FB\u5730\u4E0A\u7CFB\uFF09",
            en: "Software \u2014 control, perception, ground"
        },
        softwareBody: {
            ja: "\u4E00\u822C\u306EWeb\u30A2\u30D7\u30EA\u958B\u767A\u3068\u306F\u5225\u30EC\u30A4\u30E4\u3002\u63A8\u9032\u7CFB\u306E\u5FDC\u7B54\u3001IMU\u306E\u30CE\u30A4\u30BA\u3001\u30AB\u30E1\u30E9\u306E\u30ED\u30FC\u30EA\u30F3\u30B0\u30B7\u30E3\u30C3\u30BF\u30FC\u307E\u3067\u8E0F\u307E\u3048\u3066\u3001\u5236\u5FA1\u30EB\u30FC\u30D7\u3068\u63A8\u8AD6\u30D1\u30A4\u30D7\u30E9\u30A4\u30F3\u3092\u7D50\u7DDA\u3057\u307E\u3059\u3002",
            en: "This isn't generic web work\u2014it's closing loops between propulsion response, IMU noise, rolling shutter, and the perception graphs that must run on the payload budget you actually have."
        },
        softwareBullets: {
            ja: [
                "\u5B89\u5B9A\u5316\u30FB\u9AD8\u5EA6\u4FDD\u6301\u30FB\u30D5\u30A7\u30A4\u30EB\u30BB\u30FC\u30D5\u3092\u3001\u5B9F\u6A5F\u306E\u6163\u6027\u30FB\u63A8\u529B\u30E2\u30C7\u30EB\u306B\u5408\u308F\u305B\u3066\u30C1\u30E5\u30FC\u30CB\u30F3\u30B0",
                "\u753B\u50CF\u691C\u77E5\u30FB\u8FFD\u5F93\u30FB\u30DE\u30C3\u30D4\u30F3\u30B0\u306F\u3001\u642D\u8F09\u30AB\u30E1\u30E9\u306E\u89E3\u50CF\u5EA6\u30FBFPS\u30FB\u9732\u51FA\u524D\u63D0\u3067\u30E2\u30C7\u30EB\u3068\u5F8C\u51E6\u7406\u3092\u8A2D\u8A08",
                "\u5730\u4E0A\u5C40\u3001\u30ED\u30B0\u3001OTA\u3001\u9065\u6E2C\u306E\u30B9\u30C8\u30FC\u30EA\u30F3\u30B0\u307E\u3067\u542B\u3081\u3066\u300C\u904B\u7528\u3067\u6B7B\u306A\u306A\u3044\u300D\u5F62\u306B"
            ],
            en: [
                "Stabilization, altitude hold, and failsafes tuned against real inertia and thrust\u2014not a simulator default",
                "Detection, tracking, and mapping pipelines scoped to the resolution, FPS, and exposure you truly carry",
                "Ground station, logging, OTA, and telemetry paths designed for long-running ops\u2014not lab-only scripts"
            ]
        },
        modulesLabel: {
            ja: "\u642D\u8F09\u30E2\u30B8\u30E5\u30FC\u30EB\u4F8B\uFF08\u8981\u4EF6\u306B\u5FDC\u3058\u3066\u53EF\u5909\uFF09",
            en: "Example payloads (mission-specific)"
        },
        modulePills: {
            ja: [
                "GPS / GNSS",
                "\u6DF1\u5EA6\u30AB\u30E1\u30E9",
                "RGB\u30AB\u30E1\u30E9",
                "\u30A8\u30C3\u30B8\u63A8\u8AD6",
                "\u5B89\u5B9A\u5316\u5236\u5FA1",
                "LTE\u30FB5G",
                "\u81EA\u5F8B\u63A2\u7D22"
            ],
            en: [
                "GPS / GNSS",
                "Depth camera",
                "RGB camera",
                "Edge inference",
                "Stabilized control",
                "LTE / 5G",
                "Autonomous routing"
            ]
        },
        footnote: {
            ja: "\u8CC7\u6599\u3067\u793A\u3057\u305FPoC\u3067\u306F\u3001\u753B\u50CF\u8A8D\u8B58\u306B\u3088\u308B\u81EA\u5F8B\u63A2\u7D22\u30C9\u30ED\u30FC\u30F3\u3067\u7A7A\u64AE\u3092\u53D6\u5F97\u3057\u3001\u5206\u5E03\u53EF\u8996\u5316\u307E\u3067\u3092\u691C\u8A3C\u3002\u540C\u69D8\u306B\u3001\u76E3\u8996\u30FB\u8FB2\u696D\u30FB\u7269\u6D41\u30FB\u707D\u5BB3\u306A\u3069\u591A\u69D8\u306A\u30E6\u30FC\u30B9\u30B1\u30FC\u30B9\u3078\u30E2\u30B8\u30E5\u30FC\u30EB\u69CB\u6210\u3092\u62E1\u5F35\u3067\u304D\u307E\u3059\u3002",
            en: "Our materials walk through a PoC where a vision-guided autonomous drone captured aerials and surfaced distribution maps\u2014the same modular approach extends to security, agriculture, logistics, disaster response, and more."
        }
    },
    value: {
        title: {
            ja: "\u306A\u305C\u3001\u4ECA\u3064\u306A\u3050\u306E\u304B",
            en: "Why connect now"
        },
        body: {
            ja: "\u30C4\u30FC\u30EB\u5C0E\u5165\u3060\u3051\u3067\u306F\u73FE\u5834\u306F\u52D5\u304D\u307E\u305B\u3093\u3002\u8AB2\u984C\u306E\u8F2A\u90ED\u3092\u63CF\u304D\u3001\u30C7\u30FC\u30BF\u3068\u30A2\u30EB\u30B4\u30EA\u30BA\u30E0\u3092\u9078\u3073\u3001\u30D7\u30ED\u30C0\u30AF\u30C8\u3068\u3057\u3066\u6B8B\u3059\u307E\u3067\u3092\u77ED\u3044\u30B5\u30A4\u30AF\u30EB\u3067\u56DE\u305B\u308B\u3053\u3068\u304C\u3001\u6210\u679C\u7684\u306AAI\u306B\u306A\u308A\u307E\u3059\u3002",
            en: "Buying tools doesn't move the floor. Real AI ties problem framing, data, modeling, and product delivery into tight loops\u2014so outcomes stick."
        },
        panelCaption: {
            ja: "\u610F\u601D\u6C7A\u5B9A\u304C\u901F\u304F\u306A\u308B\u307B\u3069\u3001\u73FE\u5834\u306F\u524D\u306B\u9032\u3080\u3002\u3060\u304B\u3089\u3053\u305D\u3001\u8A2D\u8A08\u3068\u5B9F\u88C5\u3092\u540C\u3058\u30C6\u30FC\u30D6\u30EB\u306B\u8F09\u305B\u307E\u3059\u3002",
            en: "When decisions accelerate, teams move. That's why design and implementation share one table."
        },
        chips: {
            ja: [
                "\u81EA\u793EAI\u30C9\u30ED\u30FC\u30F3\uFF08\u6A5F\u4F53\u301C\u30BD\u30D5\u30C8\uFF09",
                "\u751F\u6210AI / CV / NLP / \u4E88\u6E2C",
                "\u30AF\u30E9\u30A6\u30C9\u30FB\u30C7\u30FC\u30BF\u57FA\u76E4\u30FB\u904B\u7528"
            ],
            en: [
                "In-house AI drones (airframe to software)",
                "GenAI \xb7 CV \xb7 NLP \xb7 forecasting",
                "Cloud, data platforms, operations"
            ]
        }
    },
    philosophy: {
        philosophy1: {
            ja: "\u300E\u3064\u306A\u3050\u300F\u306F\u3001\u6280\u8853\u3092\u62BC\u3057\u4ED8\u3051\u308B\u3053\u3068\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u73FE\u5834\u306E\u5236\u7D04\u3068\u6210\u679C\u6307\u6A19\u3092\u5C0A\u91CD\u3057\u3001\u8AAC\u660E\u53EF\u80FD\u3067\u4FDD\u5B88\u3067\u304D\u308B\u5F62\u306B\u843D\u3068\u3059\u3053\u3068\u3067\u3059\u3002",
            en: "'Connect' doesn't mean pushing tech. It means respecting constraints and KPIs\u2014shipping maintainable, explainable systems."
        },
        philosophy2: {
            ja: "\u660E\u308B\u304F\u3001\u524D\u5411\u304D\u306B\u3001\u305D\u308C\u3067\u3044\u3066\u30D7\u30ED\u30D5\u30A7\u30C3\u30B7\u30E7\u30CA\u30EB\u306B\u3002\u5BFE\u8A71\u3092\u91CD\u306D\u306A\u304C\u3089\u3001\u6B21\u306E\u6253\u3061\u624B\u304C\u898B\u3048\u308B\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3068\u30D7\u30ED\u30C0\u30AF\u30C8\u3092\u6B8B\u3057\u307E\u3059\u3002",
            en: "Bright, optimistic, and deeply professional. We leave behind artifacts\u2014docs and product\u2014that make the next step obvious."
        }
    },
    business: {
        business1: {
            title: {
                ja: "AI\u30B3\u30F3\u30B5\u30EB\u30C6\u30A3\u30F3\u30B0 / \u5B9F\u88C5",
                en: "AI consulting & build"
            },
            detail: {
                ja: "\u6700\u65B0\u306E\u7814\u7A76\u52D5\u5411\u3092\u8E0F\u307E\u3048\u3064\u3064\u3001ROI\u304C\u898B\u3048\u308B\u30E6\u30FC\u30B9\u30B1\u30FC\u30B9\u306B\u7D5E\u308A\u8FBC\u307F\u3002RAG\u30FBLLM\u3001\u753B\u50CF\u691C\u77E5\u30FBOCR\u3001\u9700\u8981\u4E88\u6E2C\u306A\u3069\u3001\u8AB2\u984C\u306B\u5408\u308F\u305B\u3066\u9078\u5B9A\u3057\u3001\u672C\u756A\u904B\u7528\u307E\u3067\u4F34\u8D70\u3057\u307E\u3059\u3002",
                en: "We pair research literacy with pragmatic scoping\u2014RAG/LLMs, vision & OCR, forecasting\u2014then ship to production with you, not at you."
            }
        },
        business2: {
            title: {
                ja: "\u30D3\u30C3\u30B0\u30C7\u30FC\u30BF\u89E3\u6790\u30FB\u30C7\u30FC\u30BF\u57FA\u76E4",
                en: "Big data & data platforms"
            },
            detail: {
                ja: "\u6563\u5728\u3059\u308B\u30ED\u30B0\u3084\u8CA9\u58F2\u30FB\u8A2D\u5099\u30C7\u30FC\u30BF\u3092\u53D6\u308A\u8FBC\u307F\u3001\u30AF\u30EC\u30F3\u30B8\u30F3\u30B0\u304B\u3089\u7279\u5FB4\u8A2D\u8A08\u3001\u30C0\u30C3\u30B7\u30E5\u30DC\u30FC\u30C9\u5316\u307E\u3067\u3002AWS/GCP/Azure \u4E0A\u3067\u5B66\u7FD2\u30EB\u30FC\u30D7\u304C\u56DE\u308B\u5F62\u3092\u8A2D\u8A08\u3057\u307E\u3059\u3002",
                en: "From ingestion and cleansing to features and dashboards on AWS/GCP/Azure\u2014architectures where models keep learning without silently drifting."
            }
        },
        business3: {
            title: {
                ja: "\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u958B\u767A\uFF08Web / \u30E2\u30D0\u30A4\u30EB / \u7D44\u307F\u8FBC\u307F\uFF09",
                en: "Software engineering (web, mobile & embedded)"
            },
            detail: {
                ja: "\u30D7\u30ED\u30C8\u30BF\u30A4\u30D7\u304B\u3089\u793E\u5185\u5411\u3051\u30C4\u30FC\u30EB\u3001\u5916\u90E8\u516C\u958B\u30B5\u30FC\u30D3\u30B9\u307E\u3067\u3002\u30D5\u30ED\u30F3\u30C8\u301C\u30D0\u30C3\u30AF\u30A8\u30F3\u30C9\u3001\u30A4\u30F3\u30D5\u30E9\u306B\u52A0\u3048\u3001\u81EA\u793E\u30C9\u30ED\u30FC\u30F3\u5411\u3051\u306E\u7D44\u307F\u8FBC\u307F\u30FB\u5730\u4E0A\u5C40\u30FB\u30ED\u30B0\u57FA\u76E4\u307E\u3067\u30EF\u30F3\u30C1\u30FC\u30E0\u3067\u7D44\u307F\u7ACB\u3066\u307E\u3059\u3002",
                en: "From internal tools to customer-facing apps\u2014frontend, backend, and infra\u2014plus ground stations, logging, and embedded paths for our own drone stack, delivered as one team."
            }
        }
    },
    proof: {
        title: {
            ja: "\u4E2D\u8EAB\u307E\u3067\u5177\u4F53\u7684\u306A\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u5B9F\u7E3E",
            en: "Concrete project outcomes"
        },
        subtitle: {
            ja: "\u3069\u306E\u696D\u754C\u306E\u3069\u3093\u306A\u30C6\u30FC\u30DE\u304B\u3001\u305D\u3057\u3066\u3069\u3053\u307E\u3067\u6210\u679C\u304C\u51FA\u305F\u304B\u304C\u4F1D\u308F\u308B\u3088\u3046\u3001\u696D\u7A2E\u3068\u53D6\u308A\u7D44\u307F\u306E\u5185\u5BB9\u3067\u793A\u3057\u3066\u3044\u307E\u3059\u3002\u8981\u4EF6\u306E\u6574\u7406\u3084\u8A2D\u8A08\u306B\u3068\u3069\u307E\u3089\u305A\u3001\u958B\u767A\u30FB\u691C\u8A3C\u30FB\u672C\u756A\u306B\u8FD1\u3044\u904B\u7528\u307E\u3067\u5F53\u4E8B\u8005\u3068\u3057\u3066\u95A2\u308F\u3063\u305F\u6848\u4EF6\u306E\u307F\u3092\u8F09\u305B\u3066\u3044\u307E\u3059\u3002",
            en: "We state the industry, the problem shape, and how far we took the work. These are engagements where we stayed involved past slide decks\u2014through build, validation, and production-adjacent delivery."
        },
        cases: [
            {
                tag: {
                    ja: "\u81EA\u793E\u30C9\u30ED\u30FC\u30F3 \xd7 \u8FB2\u696D",
                    en: "In-house drone"
                },
                title: {
                    ja: "\u81EA\u5F8B\u63A2\u7D22\u30C9\u30ED\u30FC\u30F3\u306B\u3088\u308B\u7A7A\u64AE\u3068\u5206\u5E03\u30DE\u30C3\u30D7\u306EPoC",
                    en: "PoC: autonomous scouting, aerials, distribution maps"
                },
                desc: {
                    ja: "\u753B\u50CF\u8A8D\u8B58\u3067\u81EA\u5F8B\u8D70\u884C\u3059\u308B\u6A5F\u4F53\u3092\u7528\u3044\u3001GPS\u9023\u643A\u3067\u5703\u5834\u4E0A\u7A7A\u3092\u8D70\u67FB\u3002\u7A7A\u64AE\u3092\u53D6\u308A\u8FBC\u307F\u3001\u75C5\u5BB3\u866B\u5206\u5E03\u306A\u3069\u306E\u53EF\u8996\u5316\u307E\u3067\u3092\u4E00\u9023\u3067\u691C\u8A3C\u3002",
                    en: "Vision-guided autonomous passes linked with GPS, ingesting aerials to validate distribution-style analytics\u2014exactly the hardware\u2013software coupling we ship in-house."
                }
            },
            {
                tag: {
                    ja: "\u9632\u707D \xd7 \u4E88\u6E2CAI",
                    en: "Resilience AI"
                },
                title: {
                    ja: "\u707D\u5BB3\u5EC3\u68C4\u7269\u306E\u767A\u751F\u91CF\u30FB\u8A2D\u7F6E\u30FB\u51E6\u7406\u30D5\u30ED\u30FC\u3092\u9AD8\u7CBE\u5EA6\u306B\u63A8\u5B9A",
                    en: "Forecasting disaster waste volumes, placement, and flows"
                },
                desc: {
                    ja: "\u516C\u5171\u30AA\u30FC\u30D7\u30F3\u30C7\u30FC\u30BF\u3068\u90FD\u5E02\u8A08\u753B\u30FB\u5730\u56F3\u60C5\u5831\u3092\u7D71\u5408\u3057\u3001\u88AB\u707D\u30D1\u30BF\u30FC\u30F3\u3054\u3068\u306E\u767A\u751F\u91CF\u3092\u53EF\u8996\u5316\u3002\u73FE\u5834\u5224\u65AD\u3092\u65E9\u3081\u308B\u30C0\u30C3\u30B7\u30E5\u30DC\u30FC\u30C9\u307E\u3067\u5B9F\u88C5\u3002",
                    en: "Fused open civic data with planning and mapping signals to surface scenario-level forecasts\u2014shipping operator-ready dashboards."
                }
            },
            {
                tag: {
                    ja: "\u8D8A\u5883EC \xd7 \u4FA1\u683CAI",
                    en: "Cross-border commerce"
                },
                title: {
                    ja: "\u30B0\u30ED\u30FC\u30D0\u30EB\u8CB7\u53D6\u30FB\u8CA9\u58F2\u30C7\u30FC\u30BF\u306E\u53CE\u96C6\u57FA\u76E4\u3068\u4FA1\u683C\u4E88\u6E2C\u30E2\u30C7\u30EB",
                    en: "Global pricing intelligence on a living dataset"
                },
                desc: {
                    ja: "\u5E38\u6642\u30AF\u30ED\u30FC\u30EB\u3059\u308B\u30C7\u30FC\u30BF\u30EC\u30A4\u30AF\u3068\u5B66\u7FD2\u30D1\u30A4\u30D7\u30E9\u30A4\u30F3\u3092\u30AF\u30E9\u30A6\u30C9\u4E0A\u306B\u69CB\u7BC9\u3002\u6700\u65B0\u76F8\u5834\u3092\u53CD\u6620\u3057\u7D9A\u3051\u308B\u4E88\u6E2C\u6A5F\u80FD\u3092\u30D7\u30ED\u30C0\u30AF\u30C8\u3078\u7D71\u5408\u3002",
                    en: "Built continuous ingestion plus cloud-native training loops so price signals refresh as markets move\u2014not as quarterly batch jobs."
                }
            },
            {
                tag: {
                    ja: "\u751F\u6210AI \xd7 \u793E\u5185\u30CA\u30EC\u30C3\u30B8",
                    en: "GenAI & knowledge"
                },
                title: {
                    ja: "RAG\u3068LLM\u3092\u7D44\u307F\u5408\u308F\u305B\u305F\u30A8\u30F3\u30BF\u30FC\u30D7\u30E9\u30A4\u30BA\u30C1\u30E3\u30C3\u30C8",
                    en: "Enterprise chat blending RAG with LLMs"
                },
                desc: {
                    ja: "\u793E\u5185\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u5B89\u5168\u306B\u691C\u7D22\u3057\u3001\u6839\u62E0\u4ED8\u304D\u3067\u56DE\u7B54\u3002\u691C\u7D22\u3068\u751F\u6210\u3092\u5206\u96E2\u3057\u305F\u30A2\u30FC\u30AD\u30C6\u30AF\u30C1\u30E3\u3067\u904B\u7528\u30B3\u30B9\u30C8\u3068\u30CF\u30EB\u30B7\u30CD\u30FC\u30B7\u30E7\u30F3\u30EA\u30B9\u30AF\u3092\u6291\u5236\u3002",
                    en: "Grounded answers over internal corpora\u2014architecture separating retrieval and generation to tame ops cost and hallucination risk."
                }
            },
            {
                tag: {
                    ja: "\u5EFA\u8A2D\u5B89\u5168 \xd7 NLP",
                    en: "Safety analytics"
                },
                title: {
                    ja: "\u6570\u4E07\u4EF6\u898F\u6A21\u306E\u707D\u5BB3\u4E8B\u4F8B\u30C6\u30AD\u30B9\u30C8\u3092\u81EA\u52D5\u5206\u985E\u30FB\u985E\u4F3C\u691C\u7D22",
                    en: "Classifying & surfacing patterns across tens of thousands of incident narratives"
                },
                desc: {
                    ja: "\u539A\u52B4\u7701\u306A\u3069\u306E\u5E83\u7BC4\u306A\u5831\u544A\u6587\u66F8\u3092\u6A5F\u68B0\u5B66\u7FD2\u3067\u30BF\u30B0\u4ED8\u3051\u3057\u3001\u985E\u4F3C\u707D\u5BB3\u3092\u77AC\u6642\u306B\u53C2\u7167\u3002\u5B9A\u6027\u60C5\u5831\u3092\u610F\u601D\u6C7A\u5B9A\u306B\u4F7F\u3048\u308B\u30C7\u30FC\u30BF\u3078\u5909\u63DB\u3002",
                    en: "Turned massive regulatory and incident corpora into navigable intelligence\u2014similar-case retrieval for proactive safety planning."
                }
            },
            {
                tag: {
                    ja: "\u30A8\u30CD\u30EB\u30AE\u30FC \xd7 \u9700\u8981\u4E88\u6E2C",
                    en: "Energy forecasting"
                },
                title: {
                    ja: "\u591A\u5909\u91CF\u30D3\u30C3\u30B0\u30C7\u30FC\u30BF\u3092\u7528\u3044\u305F\u96FB\u529B\u9700\u8981\u4E88\u6E2C\u3068\u52A3\u5316\u3057\u306B\u304F\u3044\u5B66\u7FD2\u57FA\u76E4",
                    en: "Robust power-demand forecasting on heterogeneous big data"
                },
                desc: {
                    ja: "\u6C17\u8C61\u30FB\u9700\u8981\u30FB\u518D\u30A8\u30CD\u306A\u3069\u8907\u6570\u7CFB\u5217\u3092\u7279\u5FB4\u3068\u3057\u3066\u7D71\u5408\u3002\u30E2\u30C7\u30EB\u52A3\u5316\u3092\u6291\u3048\u308B\u518D\u5B66\u7FD2\u8A2D\u8A08\u3068\u30E2\u30CB\u30BF\u30EA\u30F3\u30B0\u3092\u4E00\u4F53\u3067\u63D0\u4F9B\u3002",
                    en: "Fused weather, demand, and renewables signals with MLOps-minded refresh\u2014so accuracy doesn't quietly decay after launch."
                }
            },
            {
                tag: {
                    ja: "\u6D88\u8CBB\u8CA1 \xd7 OCR",
                    en: "Retail OCR"
                },
                title: {
                    ja: "\u30EC\u30B7\u30FC\u30C8\u753B\u50CF\u304B\u3089\u306E\u691C\u77E5\u30FB\u8A8D\u8B58\u30FB\u69CB\u9020\u5316\u30D1\u30A4\u30D7\u30E9\u30A4\u30F3",
                    en: "Detection, recognition, structuring for receipt imagery"
                },
                desc: {
                    ja: "\u30AD\u30FC\u9805\u76EE\u306E\u81EA\u52D5\u5224\u5225\u3068\u4EBA\u7684\u78BA\u8A8D\u30D5\u30ED\u30FC\u3092\u4E21\u7ACB\u3002\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0\u8ABF\u67FB\u306E\u30DC\u30C8\u30EB\u30CD\u30C3\u30AF\u3060\u3063\u305F\u8EE2\u8A18\u4F5C\u696D\u3092\u5927\u5E45\u306B\u5727\u7E2E\u3002",
                    en: "Balanced automation with human-in-the-loop QA\u2014shrinking the transcription bottleneck for consumer insight programs."
                }
            }
        ]
    },
    team: {
        title: {
            ja: "\u30C1\u30FC\u30E0\u7D39\u4ECB",
            en: "Our team\u2014by role and expertise"
        },
        subtitle: {
            ja: "\u5404\u30E1\u30F3\u30D0\u30FC\u306E\u5F79\u5272\u30FB\u7565\u6B74\u30FB\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u5B9F\u7E3E\u3092\u63B2\u8F09\u3057\u3066\u3044\u307E\u3059\u3002\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3067\u5FC5\u8981\u3068\u306A\u308B\u5F79\u5272\u3054\u3068\u306B\u3001\u3069\u306E\u3088\u3046\u306A\u5C02\u9580\u6027\u3067\u53C2\u753B\u3059\u308B\u304B\u3092\u3054\u78BA\u8A8D\u3044\u305F\u3060\u3051\u307E\u3059\u3002",
            en: "Roles, backgrounds, and project records for each member\u2014see the expertise they bring to your engagement."
        },
        roles: [
            {
                title: {
                    ja: "AI\u30B9\u30C8\u30E9\u30C6\u30B8\u30FC / \u30EA\u30B5\u30FC\u30C1",
                    en: "AI strategy & research"
                },
                body: {
                    ja: "\u753B\u50CF\u30FB\u97F3\u58F0\u30FB\u4E88\u6E2C\u30E2\u30C7\u30EB\u307E\u3067\u6A2A\u65AD\u3057\u3001\u8AD6\u6587\u3068\u5B9F\u88C5\u306E\u30AE\u30E3\u30C3\u30D7\u3092\u57CB\u3081\u308B\u3002PoC\u3067\u7D42\u308F\u3089\u305B\u305A\u3001\u672C\u756A\u6307\u6A19\u306B\u843D\u3068\u3059\u8A2D\u8A08\u3092\u30EA\u30FC\u30C9\u3002",
                    en: "Spins up CV, audio, and forecasting with equal fluency\u2014closing the lab-to-prod gap and anchoring on production KPIs."
                }
            },
            {
                title: {
                    ja: "\u30D3\u30B8\u30CD\u30B9\u958B\u767A / PM",
                    en: "BD & program leadership"
                },
                body: {
                    ja: "\u5C0F\u58F2\u306E\u7ACB\u3061\u4E0A\u3052\u304B\u3089\u88FD\u9020\u696D\u306E\u57FA\u5E79\u30EA\u30D7\u30EC\u30A4\u30B9\u307E\u3067\u3001\u5229\u5BB3\u8ABF\u6574\u3068\u30B9\u30B3\u30FC\u30D7\u7BA1\u7406\u306B\u5F37\u3044\u3002\u975E\u30A8\u30F3\u30B8\u30CB\u30A2\u3068\u306E\u8981\u4EF6\u30BB\u30C3\u30B7\u30E7\u30F3\u3092\u524D\u306B\u9032\u3081\u308B\u3002",
                    en: "From retail launches to core-system replays\u2014strong at stakeholder alignment and scope guardrails that keep teams shipping."
                }
            },
            {
                title: {
                    ja: "\u30D5\u30EB\u30B9\u30BF\u30C3\u30AF\u958B\u767A",
                    en: "Full-stack engineering"
                },
                body: {
                    ja: "React / Vue / TypeScript\u3001Ruby / Python / Node\u3001\u30B3\u30F3\u30C6\u30CA\u3068CI\u307E\u3067\u3002\u591A\u8A00\u8A9E\u30C1\u30FC\u30E0\u3067\u306E\u958B\u767A\u30D7\u30ED\u30BB\u30B9\u8A2D\u8A08\u3082\u5F97\u610F\u3002",
                    en: "React/Vue/TS, Ruby/Python/Node, containers & CI\u2014comfortable orchestrating multilingual engineering squads."
                }
            },
            {
                title: {
                    ja: "\u30AF\u30E9\u30A6\u30C9 / PMO",
                    en: "Cloud & PMO"
                },
                body: {
                    ja: "\u5927\u898F\u6A21\u30A4\u30F3\u30D5\u30E9\u6848\u4EF6\u3067\u935B\u3048\u305F\u30A2\u30FC\u30AD\u30C6\u30AF\u30C1\u30E3\u3068\u30AC\u30D0\u30CA\u30F3\u30B9\u3002\u77ED\u671F\u9593\u3067\u306E\u672C\u756A\u79FB\u884C\u3001\u904B\u7528\u5F15\u304D\u7D99\u304E\u3001\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u89B3\u70B9\u306E\u6574\u7406\u307E\u3067\u542B\u3081\u308B\u3002",
                    en: "Architecture and governance hardened on large programs\u2014tight cutovers, operational handoffs, and pragmatic security framing."
                }
            },
            {
                title: {
                    ja: "\u7D44\u307F\u8FBC\u307F / \u30C9\u30ED\u30FC\u30F3\u5B9F\u88C5",
                    en: "Embedded & drone stack"
                },
                body: {
                    ja: "\u98DB\u884C\u5236\u5FA1\u30FB\u30BB\u30F3\u30B5\u878D\u5408\u30FB\u30A8\u30C3\u30B8\u63A8\u8AD6\u307E\u3067\u3001\u6A5F\u4F53\u306E\u7269\u7406\u5236\u7D04\u3092\u524D\u63D0\u306B\u5B9F\u88C5\u3002\u30C9\u30ED\u30FC\u30F3\u4E8B\u696D\u3067\u306F\u30CF\u30FC\u30C9\u9078\u5B9A\u3068\u540C\u3058\u30C1\u30FC\u30E0\u304C\u30BD\u30D5\u30C8\u3092\u66F8\u304D\u5207\u308B\u3002",
                    en: "Flight stacks, sensor fusion, and edge inference written against physical limits\u2014the same squad that picks hardware also ships the code."
                }
            }
        ]
    },
    sectionLabels: {
        services: {
            ja: "\u63D0\u4F9B\u30B5\u30FC\u30D3\u30B9",
            en: "What we deliver"
        },
        philosophyHeading: {
            ja: "\u8003\u3048\u65B9",
            en: "Belief"
        }
    },
    contact: {
        heading: {
            ja: "\u6B21\u306E\u4E00\u6B69\u3092\u3001\u5177\u4F53\u306B\u3059\u308B",
            en: "Make the next step concrete"
        },
        description: {
            ja: "\u307E\u305A\u306F\u8AB2\u984C\u306E\u8F2A\u90ED\u304B\u3089\u3002\u8CC7\u6599\u306F\u4E0D\u8981\u3067\u3059\u3001\u30AA\u30F3\u30E9\u30A4\u30F3\u306730\u5206\u304A\u8A71\u3057\u3057\u307E\u3057\u3087\u3046\u3002",
            en: "Start messy\u2014we like it. No slide deck required; book a 30-minute virtual chat."
        },
        buttonText: {
            ja: "\u304A\u554F\u3044\u5408\u308F\u305B\u30D5\u30A9\u30FC\u30E0\u3078",
            en: "Go to contact form"
        },
        formLink: {
            ja: "\u304A\u554F\u3044\u5408\u308F\u305B\u30D5\u30A9\u30FC\u30E0",
            en: "Contact form"
        },
        formUrl: "https://docs.google.com/forms/d/e/1FAIpQLSc45BmyZVwICEmeBl_PPQsOA6Q96N1bLEHCi6j8d5pB-0aGTA/viewform?embedded=true"
    },
    company: {
        name: {
            ja: "\u4F1A\u793E\u540D: \u682A\u5F0F\u4F1A\u793ENAPIRE (\u82F1\u6587\u793E\u540D: NAPIRE Inc.)",
            en: "Company Name: NAPIRE Inc."
        },
        representative: {
            ja: "",
            en: ""
        },
        builtDate: {
            ja: "\u8A2D\u7ACB\u65E5: 2024/01/04",
            en: "Established: 2024/01/04"
        },
        place: {
            ja: "\u30AA\u30D5\u30A3\u30B9\u6240\u5728\u5730: \u3012107-0062 \u6771\u4EAC\u90FD\u6E2F\u533A\u5357\u9752\u5C713\u4E01\u76EE1\u756A36\u53F7\u9752\u5C71\u4E38\u7AF9\u30D3\u30EB6F",
            en: "Office Location: \u3012107-0062  Aoyamamarutake 6F, 3-1-36 Minamiaoyama, Minato-ku, Tokyo, Japan"
        },
        content: {
            ja: "\u4E8B\u696D\u5185\u5BB9: \u6CD5\u4EBA\u5411\u3051AI\u30FBDX\u5C0E\u5165\u652F\u63F4\u3001SaaS\u30FB\u30AF\u30E9\u30A6\u30C9\u5C0E\u5165\u652F\u63F4\u3001AI\u958B\u767A/\u30B3\u30F3\u30B5\u30EB\u30C6\u30A3\u30F3\u30B0\u3001\u30D3\u30C3\u30B0\u30C7\u30FC\u30BF\u89E3\u6790\u3001\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u958B\u767A\u3001\u81EA\u793EAI\u30C9\u30ED\u30FC\u30F3\u958B\u767A",
            en: "Business: Enterprise AI/DX, SaaS & cloud rollout, AI consulting, big data, software engineering, in-house AI drones"
        },
        capital: {
            ja: "\u8CC7\u672C\u91D1: 1,000,000\u5186",
            en: "Capital: 1,000,000 yen"
        }
    },
    vision: {
        title: {
            ja: "\u30D3\u30B8\u30E7\u30F3",
            en: "vision"
        },
        description1: {
            ja: "\u5F0A\u793E\u304C\u6301\u3061\u5408\u308F\u305B\u3066\u3044\u308BAI\u6280\u8853\u3084\u9AD8\u5EA6IT\u6280\u8853\u3092\u69D8\u3005\u306A\u4F01\u696D\u306B\u63D0\u4F9B\u3057\u3001\u30D3\u30B8\u30CD\u30B9\u306B\u66F4\u306A\u308B\u52A0\u901F\u3092\u751F\u307F\u51FA\u3057\u307E\u3059\u3002",
            en: "We provide our AI and advanced IT technologies to various companies to further accelerate their business."
        },
        description2: {
            ja: "DX\u5354\u696D\u3092\u884C\u3063\u3066\u30D3\u30B8\u30CD\u30B9\u3092\u52A0\u901F\u3055\u305B\u305F\u3044\u65B9\u306F\u305C\u3072\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002",
            en: "If you are interested in accelerating your business through DX collaboration, please contact us."
        },
        button: {
            ja: "\u9023\u7D61",
            en: "contact"
        },
        image: {
            ja: "dx_kyougyou.png",
            en: "dx_kyougyou_en.png"
        }
    }
};

//# sourceMappingURL=ai-dx.e088b123.js.map
